import React, { useMemo } from 'react';
import { ZapIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/**
 * Launch bar pinned to the top of the page. It carries the discount claim and
 * the live countdown to midnight, so the urgency is always on screen.
 */
export function UrgencyBar() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  return <div className="sticky top-0 z-50 w-full bg-flame text-shell" data-id="element-200" data-mp="2p5bzbx41r36z">
      
    </div>;
}